/**
 * DateField — a `date` attribute (PIM Wave P2, Task 3). Native date input
 * yields a `YYYY-MM-DD` string, exactly what the backend `date.fromisoformat`
 * accepts and stores.
 */
import type { ReactElement } from "react";

import {
  pickOptionalText,
  pickText,
} from "@/features/seller-dashboard/attributes/formSchema";
import {
  ATTR_INPUT_CLASS,
  ATTR_INPUT_ERROR_CLASS,
  FieldShell,
  type AttributeFieldProps,
} from "@/features/seller-dashboard/attributes/fields/FieldShell";

export function DateField({
  field,
  language,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}: AttributeFieldProps): ReactElement {
  const label = pickText(field.label, language);
  const hint = pickOptionalText(field.hint, language);
  const controlId = `attr-${field.field_slug}`;
  return (
    <FieldShell
      slug={field.field_slug}
      label={label}
      requirement={field.requirement}
      hint={hint}
      error={error}
    >
      <input
        id={controlId}
        type="date"
        aria-label={label}
        aria-invalid={error ? true : undefined}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={[ATTR_INPUT_CLASS, error ? ATTR_INPUT_ERROR_CLASS : ""].join(" ")}
      />
    </FieldShell>
  );
}

export default DateField;
